export const ceoData = {
  id: 'ceo',
  title: 'CEO/CTO',
  icon: 'Award',
  color: 'from-yellow-500 to-orange-600',
  description: 'Recursos de liderazgo, estrategia y análisis de negocio',
  categories: [
    {
      name: 'Liderazgo',
      icon: 'TrendingUp',
      resources: [
        {
          id: 'leadership-1',
          title: 'Gestión de Equipos - Estrategias',
          type: 'Guía',
          description: 'Estrategias efectivas para gestión de equipos de desarrollo, incluyendo modelos de liderazgo y resolución de conflictos.',
          tags: ['Liderazgo', 'Gestión', 'Equipos'],
          difficulty: 'Avanzado',
          estimatedTime: '3h',
          lastUpdated: '2024-01-15',
          author: 'Leadership Team',
          downloads: 89,
          rating: 4.9,
          content: {
            sections: [
              {
                title: 'Modelos de Liderazgo',
                content: 'Diferentes enfoques de liderazgo y su aplicación en equipos de desarrollo tecnológico.',
                subsections: [
                  'Transformational leadership',
                  'Servant leadership',
                  'Situational leadership',
                  'Democratic leadership',
                  'Adaptive leadership'
                ]
              },
              {
                title: 'Motivación de Equipos',
                content: 'Estrategias para mantener equipos motivados y comprometidos con los objetivos del proyecto.',
                subsections: [
                  'Intrinsic motivation',
                  'Recognition and rewards',
                  'Career development',
                  'Work-life balance',
                  'Team building activities'
                ]
              },
              {
                title: 'Resolución de Conflictos',
                content: 'Técnicas efectivas para identificar y resolver conflictos en equipos de desarrollo.',
                subsections: [
                  'Conflict identification',
                  'Communication strategies',
                  'Mediation techniques',
                  'Problem-solving approaches',
                  'Prevention strategies'
                ]
              },
              {
                title: 'Delegación Efectiva',
                content: 'Metodologías para delegar responsabilidades de manera efectiva y empoderar equipos.',
                subsections: [
                  'Task analysis',
                  'Team capability assessment',
                  'Clear communication',
                  'Support and resources',
                  'Progress monitoring'
                ]
              },
              {
                title: 'Feedback y Evaluación',
                content: 'Sistemas de feedback constructivo y evaluación de performance de equipos.',
                subsections: [
                  '360-degree feedback',
                  'Performance metrics',
                  'Regular check-ins',
                  'Goal setting',
                  'Development planning'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Gestion-Equipos-Guia.pdf',
              type: 'application/pdf',
              size: 3584000
            },
            {
              name: 'Plantillas-Liderazgo.zip',
              type: 'application/zip',
              size: 2048000
            }
          ],
          externalLinks: [
            {
              title: 'Leadership Best Practices',
              description: 'Mejores prácticas en liderazgo de equipos',
              url: 'https://hbr.org/topic/leadership'
            }
          ]
        },
        {
          id: 'leadership-2',
          title: 'Estrategia Tecnológica',
          type: 'Documentación',
          description: 'Desarrollo de estrategia tecnológica integral para empresas, incluyendo roadmap y medición de resultados.',
          tags: ['Estrategia', 'Tecnología', 'Negocio'],
          difficulty: 'Avanzado',
          estimatedTime: '4h',
          lastUpdated: '2024-01-10',
          author: 'Strategy Team',
          downloads: 67,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Análisis del Entorno',
                content: 'Evaluación del entorno tecnológico y competitivo para informar decisiones estratégicas.',
                subsections: [
                  'Technology landscape analysis',
                  'Competitive intelligence',
                  'Market trends',
                  'Regulatory environment',
                  'Risk assessment'
                ]
              },
              {
                title: 'Definición de Objetivos',
                content: 'Establecimiento de objetivos tecnológicos alineados con la estrategia de negocio.',
                subsections: [
                  'Business alignment',
                  'Technology objectives',
                  'Success metrics',
                  'Timeline planning',
                  'Resource requirements'
                ]
              },
              {
                title: 'Roadmap Tecnológico',
                content: 'Desarrollo de roadmap tecnológico para implementar la estrategia de manera gradual.',
                subsections: [
                  'Technology phases',
                  'Implementation timeline',
                  'Dependency mapping',
                  'Resource allocation',
                  'Risk mitigation'
                ]
              },
              {
                title: 'Inversión en Tecnología',
                content: 'Estrategias para optimizar inversiones en tecnología y maximizar ROI.',
                subsections: [
                  'Investment prioritization',
                  'Cost-benefit analysis',
                  'Technology evaluation',
                  'Vendor selection',
                  'ROI measurement'
                ]
              },
              {
                title: 'Medición de Resultados',
                content: 'Sistemas de medición y KPIs para evaluar el éxito de la estrategia tecnológica.',
                subsections: [
                  'Key performance indicators',
                  'Success metrics',
                  'Progress tracking',
                  'Impact assessment',
                  'Strategy adjustment'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Technology Strategy Framework',
              description: 'Framework para estrategia tecnológica',
              url: 'https://www.mckinsey.com/capabilities/mckinsey-digital/our-insights'
            }
          ]
        }
      ]
    },
    {
      name: 'Negocios',
      icon: 'BarChart3',
      resources: [
        {
          id: 'business-1',
          title: 'Análisis Financiero - Métricas',
          type: 'Guía',
          description: 'Métricas clave para análisis financiero de proyectos tecnológicos y evaluación de inversiones.',
          tags: ['Finanzas', 'Métricas', 'Análisis'],
          difficulty: 'Intermedio',
          estimatedTime: '2.5h',
          lastUpdated: '2024-01-12',
          author: 'Finance Team',
          downloads: 123,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'ROI de Proyectos',
                content: 'Cálculo y análisis del retorno de inversión en proyectos tecnológicos.',
                subsections: [
                  'ROI calculation methods',
                  'Time value of money',
                  'Risk-adjusted returns',
                  'Payback period',
                  'Net present value'
                ]
              },
              {
                title: 'Costos de Desarrollo',
                content: 'Análisis detallado de costos en el desarrollo de software y proyectos tecnológicos.',
                subsections: [
                  'Development costs',
                  'Infrastructure costs',
                  'Maintenance costs',
                  'Opportunity costs',
                  'Cost optimization'
                ]
              },
              {
                title: 'Métricas de Productividad',
                content: 'Indicadores de productividad para equipos de desarrollo y proyectos tecnológicos.',
                subsections: [
                  'Velocity metrics',
                  'Quality metrics',
                  'Efficiency indicators',
                  'Team performance',
                  'Process optimization'
                ]
              },
              {
                title: 'Análisis de Rentabilidad',
                content: 'Evaluación de la rentabilidad de proyectos y productos tecnológicos.',
                subsections: [
                  'Profit margin analysis',
                  'Break-even analysis',
                  'Revenue projections',
                  'Cost structure analysis',
                  'Profitability drivers'
                ]
              },
              {
                title: 'Presupuestación',
                content: 'Metodologías para presupuestación efectiva de proyectos tecnológicos.',
                subsections: [
                  'Budget planning',
                  'Cost estimation',
                  'Budget monitoring',
                  'Variance analysis',
                  'Budget optimization'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Analisis-Financiero-Guia.pdf',
              type: 'application/pdf',
              size: 2560000
            }
          ]
        },
        {
          id: 'business-2',
          title: 'Pitch de Productos - Técnicas',
          type: 'Tutorial',
          description: 'Técnicas avanzadas para presentar productos tecnológicos de manera efectiva a stakeholders.',
          tags: ['Pitch', 'Presentación', 'Productos'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-16',
          author: 'Sales Team',
          downloads: 98,
          rating: 4.6,
          content: {
            sections: [
              {
                title: 'Estructura del Pitch',
                content: 'Estructura efectiva para presentaciones de productos tecnológicos.',
                subsections: [
                  'Opening hook',
                  'Problem statement',
                  'Solution presentation',
                  'Market opportunity',
                  'Call to action'
                ]
              },
              {
                title: 'Storytelling',
                content: 'Técnicas de storytelling para conectar emocionalmente con la audiencia.',
                subsections: [
                  'Narrative structure',
                  'Character development',
                  'Conflict resolution',
                  'Emotional appeal',
                  'Memorable moments'
                ]
              },
              {
                title: 'Demostraciones',
                content: 'Estrategias para demostraciones efectivas de productos tecnológicos.',
                subsections: [
                  'Demo preparation',
                  'User journey mapping',
                  'Interactive elements',
                  'Technical setup',
                  'Contingency planning'
                ]
              },
              {
                title: 'Manejo de Objeciones',
                content: 'Técnicas para manejar objeciones y preguntas difíciles durante presentaciones.',
                subsections: [
                  'Objection identification',
                  'Response strategies',
                  'Active listening',
                  'Solution presentation',
                  'Follow-up actions'
                ]
              },
              {
                title: 'Follow-up',
                content: 'Estrategias de seguimiento post-presentación para mantener el engagement.',
                subsections: [
                  'Follow-up timing',
                  'Content personalization',
                  'Relationship building',
                  'Progress tracking',
                  'Next steps planning'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Pitch Deck Templates',
              description: 'Plantillas para presentaciones de productos',
              url: 'https://www.slideshare.net/'
            }
          ]
        }
      ]
    },
    {
      name: 'Innovación & Tendencias',
      icon: 'Lightbulb',
      resources: [
        {
          id: 'innovation-1',
          title: 'Tendencias Tech 2024',
          type: 'Reporte',
          description: 'Análisis comprehensivo de tendencias tecnológicas emergentes para 2024 y su impacto en el negocio.',
          tags: ['Tendencias', 'Tecnología', 'Innovación'],
          difficulty: 'Intermedio',
          estimatedTime: '1.5h',
          lastUpdated: '2024-01-05',
          author: 'Innovation Team',
          downloads: 156,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Inteligencia Artificial',
                content: 'Avances en IA y su aplicación en diferentes industrias y sectores.',
                subsections: [
                  'Generative AI',
                  'Machine learning advances',
                  'AI ethics and governance',
                  'Industry applications',
                  'Future implications'
                ]
              },
              {
                title: 'Machine Learning',
                content: 'Evolución del machine learning y su impacto en la automatización y toma de decisiones.',
                subsections: [
                  'Deep learning',
                  'Neural networks',
                  'Automated ML',
                  'MLOps',
                  'Business applications'
                ]
              },
              {
                title: 'Cloud Computing',
                content: 'Tendencias en cloud computing y su evolución hacia edge computing y multi-cloud.',
                subsections: [
                  'Multi-cloud strategies',
                  'Edge computing',
                  'Serverless architecture',
                  'Cloud security',
                  'Cost optimization'
                ]
              },
              {
                title: 'Cybersecurity',
                content: 'Amenazas emergentes y soluciones de seguridad para proteger activos digitales.',
                subsections: [
                  'Zero trust security',
                  'AI-powered security',
                  'Threat intelligence',
                  'Compliance requirements',
                  'Incident response'
                ]
              },
              {
                title: 'Sustainable Tech',
                content: 'Tecnologías sostenibles y su papel en la transformación digital responsable.',
                subsections: [
                  'Green computing',
                  'Energy efficiency',
                  'Circular economy',
                  'Carbon footprint reduction',
                  'Sustainable innovation'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Tendencias-Tech-2024.pdf',
              type: 'application/pdf',
              size: 4096000
            }
          ],
          externalLinks: [
            {
              title: 'Gartner Technology Trends',
              description: 'Tendencias tecnológicas de Gartner',
              url: 'https://www.gartner.com/en/topics/technology-trends'
            }
          ]
        },
        {
          id: 'innovation-2',
          title: 'Innovación en Startups',
          type: 'Casos de Estudio',
          description: 'Casos de estudio detallados de innovación en startups tecnológicas y lecciones aprendidas.',
          tags: ['Startups', 'Innovación', 'Casos de Estudio'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-18',
          author: 'Innovation Team',
          downloads: 87,
          rating: 4.5,
          content: {
            sections: [
              {
                title: 'Modelos de Negocio',
                content: 'Análisis de modelos de negocio innovadores en startups tecnológicas.',
                subsections: [
                  'SaaS models',
                  'Marketplace platforms',
                  'Subscription services',
                  'Freemium strategies',
                  'Platform business models'
                ]
              },
              {
                title: 'Estrategias de Crecimiento',
                content: 'Estrategias efectivas para escalar startups tecnológicas de manera sostenible.',
                subsections: [
                  'Growth hacking',
                  'Customer acquisition',
                  'Retention strategies',
                  'Scaling operations',
                  'Market expansion'
                ]
              },
              {
                title: 'Financiamiento',
                content: 'Estrategias de financiamiento y fuentes de capital para startups tecnológicas.',
                subsections: [
                  'Venture capital',
                  'Angel investors',
                  'Crowdfunding',
                  'Government grants',
                  'Revenue-based financing'
                ]
              },
              {
                title: 'Escalabilidad',
                content: 'Desafíos y soluciones para escalar operaciones y tecnología en startups.',
                subsections: [
                  'Technical scalability',
                  'Operational scaling',
                  'Team scaling',
                  'Process optimization',
                  'Infrastructure scaling'
                ]
              },
              {
                title: 'Lecciones Aprendidas',
                content: 'Lecciones clave y mejores prácticas extraídas de casos de estudio de startups exitosas.',
                subsections: [
                  'Common pitfalls',
                  'Success factors',
                  'Risk management',
                  'Team building',
                  'Market timing'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Startup Innovation Hub',
              description: 'Centro de innovación para startups',
              url: 'https://www.startupgrind.com/'
            }
          ]
        }
      ]
    }
  ]
};
